<template>
  <table class="table-sm m-0">
    <tr>
      <td>{{ $t('fareGroup.data.free_pt_change_duration') }}:</td>
      <td class="pl-2">{{ details.free_pt_change_duration }}</td>
    </tr>
  </table>
</template>
<script>

export default {
  name: 'fare-group-additional-details',
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>
